import React, { useState } from 'react';
import MenuItem from '@mui/material/MenuItem';
import { Box } from '@mui/material';
import { ButtonDropdown } from 'framework/form';
import { FiltersListLayoutProps } from '../types';
import useFiltersListHelper from '../useFiltersListHelper';
import AddIcon from '@mui/icons-material/AddOutlined';
import FilterIcon from '@mui/icons-material/FilterAltOutlined';

const ListFiltersListLayout = ({
  selectedFilters = [],
  filters,
  toggleFilter,
  showAsIcon = false,
}: FiltersListLayoutProps) => {
  const { getFilterOptions } = useFiltersListHelper({ filters });
  const options = getFilterOptions();
  const [isMenuShown, setIsMenuShown] = useState(false);

  const toggleMenu = () => setIsMenuShown(!isMenuShown);

  return (
    <>
      {selectedFilters
        .filter(item => item.selected && !item.disabled)
        .map(({ label, element, id, source }) => {
          return (
            <Box
              key={`filter${source}`}
              className="filter-item-wrapper"
              sx={{
                display: 'inline-flex',
                marginRight: '12px',
                marginBottom: '12px',
                '& .input-loader': { transform: 'translateY(5px)' },
              }}
            >
              {React.cloneElement(element, {
                onRemoveCallback: () => toggleFilter(id),
                label,
                source,
                key: source,
              })}
            </Box>
          );
        })}
      {!!options.length && (
        <Box
          sx={{
            display: 'inline-flex',
            marginRight: '12px',
            marginBottom: '16px',
            '& > button': {
              transform: 'translateY(5px)',
              border: '0 !important',
              paddingTop: '3px',
              paddingBottom: '3px',
              minHeight: '31px',
              '& > svg:last-of-type': { display: 'none' },
            },
          }}
        >
          <ButtonDropdown
            label={
              showAsIcon ? (
                <FilterIcon color="action" />
              ) : (
                <>
                  <AddIcon sx={{ fontSize: '20px', marginRight: 1 }} />
                  Add Filter
                </>
              )
            }
            toggleMenu={toggleMenu}
            isOpen={isMenuShown}
            className="add-filter-button"
          >
            {options.map(({ value, label, disabled }) => (
              <MenuItem
                key={value}
                onClick={() => {
                  toggleFilter(value);
                  toggleMenu();
                }}
                className="button-dropdown__menu-item"
                disabled={disabled}
              >
                {label}
              </MenuItem>
            ))}
          </ButtonDropdown>
        </Box>
      )}
    </>
  );
};

export default ListFiltersListLayout;
